export default {
    APP_ENV: "PROD",
    // DEV_URL: 'https://walletserver.greenlighttrust.com/devwalletservice',
    // DEV_URL: 'http://44.213.171.19:5010',
    // DEV_URL:'http://18.191.70.156:5010',

    PROD_URL: 'https://issue.glcredentials.com/webhook/', //GLC-web-hook

    DEV_URL: 'https://uatissue.glcredentials.com/walletservice', //GLC-web-hook



    // PROD_URL: 'https://walletserver.greenlighttrust.com/walletservice' //GLC-wallet
}